import { I18nUtils } from '../../../../i18n/I18nUtils';

export class MachineFormValidator {

    static validate(values) {
        const {
            brand,
            model,
            description,
            outsource,
            // contractorSchema,
        } = values;

        const errors = {};
        const emptyFieldError = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');

        if ( !brand ) errors.brand = emptyFieldError;
        if ( !model ) errors.model = emptyFieldError;
        if ( !description ) errors.description = emptyFieldError;
        if ( outsource.length === 0 ) errors.outsource = emptyFieldError;

        return errors;
    };

}



// WEBPACK FOOTER //
// ./src/app/my-outsources/machine/form/MachineFormValidator.js